module.exports = __webpack_public_path__ + "static/img/Scorpio.de75a80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/zodiac_image/Scorpio.svg
// module id = 1403
// module chunks = 0